<!-- section start -->
<section class="agency blog blog-sec blog-sidebar">
    <div class="container">
        <div class="row">
            <div class="col-lg-9 order-lg-2">
                <div class="row px-0 px-sm-auto">
                    <div class="col-md-6" *ngFor="let blog of blogService.blogs | blogFilter: { category: category }">
                        <div class="blog-agency">
                            <div class="blog-contain">
                                <img [defaultImage]="defaultImage" [lazyLoad]="blog.cover" [alt]="blog.title" class="img-fluid blog-cover" [routerLink]="['/blog', blog.code]">
                                <div class="img-container center-content">
                                    <div class="center-content">
                                        <div class="blog-info">
                                            <div class="m-b-20">
                                                <div class="center-text">
                                                    <i class="fa fa-clock-o m-r-10" aria-hidden="true"></i>
                                                    <h6 class="m-r-25 font-blog">{{ blog.createdAt | date: 'longDate' }}</h6>
                                                    <i class="fa fa-paperclip m-r-10" aria-hidden="true"></i>
                                                    <h6 class="font-blog">{{blog.author}}</h6>
                                                </div>
                                            </div>
                                            <h5 class="blog-head font-600" [routerLink]="['/blog', blog.code]">{{blog.title}}</h5>
                                            <!-- <p class="para2">{{blog.content}}</p> -->
                                            <div class="btn-bottom m-t-20">
                                                <a [routerLink]="['/blog', blog.code]" class="text-uppercase" [title]="blog.title">{{ 'ReadMore' | translate }}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3">
                <app-sidebar [filterByCategory]="filterByCategory"></app-sidebar>
            </div>
        </div>
    </div>
</section>
<!-- section end -->